import api, { apiBaseURL } from "@/services/api";

function readStoredUser() {
  for (const storage of [localStorage, sessionStorage]) {
    for (const key of ["rrpl_user", "user"]) {
      try {
        const raw = storage.getItem(key);
        if (raw) {
          const u = JSON.parse(raw);
          if (u?.token) return u;
        }
      } catch {
        /* ignore */
      }
    }
  }
  return null;
}

export function getContaChatWsUrl() {
  const token = readStoredUser()?.token;
  if (!token) return null;
  const wsBase = apiBaseURL.replace(/^http/i, "ws");
  return `${wsBase}/api/v1/ws/conta-chat?token=${encodeURIComponent(token)}`;
}

export function mediaUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${apiBaseURL.replace(/\/$/, "")}${path}`;
}

export function formatChatTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const h = String(d.getHours()).padStart(2, "0");
  const m = String(d.getMinutes()).padStart(2, "0");
  return `${h}:${m}`;
}

export function isImageFile(name) {
  if (!name) return false;
  return /\.(jpe?g|png|gif|webp)$/i.test(name);
}

export function isVideoFile(name) {
  if (!name) return false;
  return /\.(mp4|webm|mov)$/i.test(name);
}

/** Cliente WebSocket do chat de suporte. */
export class ContaChatSocket {
  constructor({ onMessage, onOpen, onClose, onError } = {}) {
    this.onMessage = onMessage;
    this.onOpen = onOpen;
    this.onClose = onClose;
    this.onError = onError;
    this.ws = null;
    this._pingTimer = null;
  }

  connect() {
    const url = getContaChatWsUrl();
    if (!url) {
      this.onError?.("Sessão inválida. Inicia sessão novamente.");
      return;
    }
    this.disconnect();
    this.ws = new WebSocket(url);
    this.ws.onopen = () => {
      this._pingTimer = setInterval(() => {
        if (this.ws?.readyState === WebSocket.OPEN) {
          this.ws.send(JSON.stringify({ type: "ping" }));
        }
      }, 25000);
      this.onOpen?.();
    };
    this.ws.onmessage = (ev) => {
      try {
        const data = JSON.parse(ev.data);
        if (data.type === "pong") return;
        this.onMessage?.(data);
      } catch {
        /* ignore */
      }
    };
    this.ws.onclose = () => {
      clearInterval(this._pingTimer);
      this.onClose?.();
    };
    this.ws.onerror = () => {
      this.onError?.("Erro na ligação do chat.");
    };
  }

  disconnect() {
    clearInterval(this._pingTimer);
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }

  sendText(texto, idUsuario = null) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      throw new Error("Chat desligado. Tenta reconectar.");
    }
    const payload = { type: "send", texto: texto.trim() };
    if (idUsuario != null) payload.id_usuario = idUsuario;
    this.ws.send(JSON.stringify(payload));
  }
}

export async function fetchFanMessages() {
  const { data } = await api.get("/api/v1/public/conta/chat/mensagens");
  return data;
}

export async function uploadFanFile(file, texto) {
  const fd = new FormData();
  fd.append("ficheiro", file);
  if (texto?.trim()) fd.append("texto", texto.trim());
  const { data } = await api.post("/api/v1/public/conta/chat/ficheiro", fd, {
    timeout: 120000,
  });
  return data;
}

export async function fetchAdminConversas() {
  const { data } = await api.get("/api/v1/admin/conta-chat/conversas");
  return data;
}

export async function fetchAdminMessages(idUsuario) {
  const { data } = await api.get(`/api/v1/admin/conta-chat/conversas/${idUsuario}/mensagens`);
  return data;
}

export async function uploadAdminFile(idUsuario, file, texto) {
  const fd = new FormData();
  fd.append("ficheiro", file);
  if (texto?.trim()) fd.append("texto", texto.trim());
  const { data } = await api.post(
    `/api/v1/admin/conta-chat/conversas/${idUsuario}/ficheiro`,
    fd,
    { timeout: 120000 },
  );
  return data;
}
